import React from "react";

function PersonBio({ name, role, imgSrc, children }) {
  return (
    <article className="bio-card" aria-labelledby={`${name}-name`}>
      <div className="bio-inner">
        <div className="bio-avatar">
          {imgSrc ? <img src={imgSrc} alt={`${name} headshot`} /> : null}
        </div>

        {/* NEW: header area sits to the right of the image */}
        <div className="bio-header">
          <h3 id={`${name}-name`} className="bio-name">{name}</h3>
          <p className="bio-role">{role}</p>
        </div>

        {/* Text now spans full width BELOW the image + header */}
        <div className="bio-text">{children}</div>
      </div>
    </article>
  );
}

export default function About(){
  return (
    <main className="container" style={{ paddingBottom: 60 }}>
      <header className="about-hero">
        <h1 className="masthead">About the minds behind Soft Tech Talks</h1>
        <p className="subhead">
          A short, visual, practice-first magazine series — learn the math, then build, one issue at a time.
        </p>
      </header>

      {/* Side-by-side on tablet/web; stacked on mobile */}
      <section className="about-list">
        <PersonBio
          name="Suhana Pathan"
          role="Builder • Engineer • Designer"
          imgSrc="/assets/people/suhana.jpg"
        >
          <p>
            I don’t believe in drawing hard lines between logic and creativity. 
            To me, engineering and design are two sides of the same craft — one grounded in precision, the other in expression.
          </p>
          <p>
            Some days I’m deep in systems — optimizing schedulers, designing data pipelines, and shaping architectures that stand the test of scale. Other days, I’m crafting experiences — sketching interfaces, tuning aesthetics, and writing to make ideas clear. 
            I’ve built fuel optimization engines, personal storytelling platforms, playful digital spaces, and research on trust in networks. Each project reflects the same thread: thoughtful systems, built with care.
          </p>
          <p>
            Right now, I’m finishing my degree in Computer Science at MIT World Peace University while leading projects that bridge AI/ML engineering with human-centered design. 
            I see technology not just as infrastructure but as experience — something people should be able to trust, use with ease, and even enjoy.
          </p>
          <p>
            Above all, I’m a builder — curious, precise, and always drawn to the intersection of systems and stories.
          </p>
          <div className="bio-actions">
            <a className="btn outline" href="/contact">Contact us</a>
          </div>
        </PersonBio>

        <PersonBio
          name="Swara Kadam"
          role="Artist • Engineer • Learner"
          imgSrc="/assets/people/swara.jpg"
        >
          <p>
            I don’t believe in sticking to one path. Born in India, raised in California, and now back in India, I’ve carried pieces of each place into the way I work and the way I learn.
          </p>
          <p>            
            Some days I’m an artist — a violinist, a writer, a designer. Other days I’m an engineer — building systems, training models, and testing ideas until they work. 
            I’ve created music, drawn sketches, designed websites, and built algorithms. For me, art and technology aren’t opposites; 
            they’re just different ways of making sense of the world.
          </p>
          <p>
            Right now, I’m leading AI/ML engineering at Buttery, a New York–based startup. There, I design machine learning frameworks and explore how distributed intelligence can power the future. 
            At the same time, I’m studying Computer Science at MIT World Peace University, and I see Soft Tech Talks as a way to share what I learn with others.
          </p>
          <p>
            Above all, I’m a student — endlessly curious, constantly experimenting, and always looking for the next question worth asking.
          </p>
          <div className="bio-actions">
            <a className="btn outline" href="/magazines">See latest issues</a>
          </div>
        </PersonBio>
      </section>

      {/* Optional pull-quote
      <div className="about-quote">“Magazines that feel like a studio session, not a textbook.”</div>
      */}
    </main>
  );
}
